import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnInit,
  ViewChild
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { AppService } from '../services/app.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { menuItems } from './consts';
import { MatIcon } from '@angular/material/icon';
import { MatTreeModule, } from '@angular/material/tree';
import { normalizePath } from '../shared/utils';
import { NavMenu } from './model';

@Component({
  selector: 'app-left-side-nav',
  imports: [
    MatSidenavModule,
    MatTreeModule,
    MatIcon,
  ],
  templateUrl: './left-side-nav.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './left-side-nav.component.scss'
})
export class LeftSideNavComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSidenav, {static: true}) public sidenav!: MatSidenav;
  public isCollapsed = true;
  public activeRootMenuItem?: NavMenu;
  public dataSource = menuItems;
  public childrenAccessor = (node: NavMenu): NavMenu[] => node.children ?? [];
  public hasChild = (_: number, node: NavMenu): boolean => !!node.children && node.children.length > 0;

  private activeNodeId = '';
  private readonly router = inject(Router);
  private readonly appService = inject(AppService);
  private readonly destroy = inject(DestroyRef);
  private readonly cd = inject(ChangeDetectorRef);


  public select(node: NavMenu): void {
    if (node.children && !this.isCollapsed) {
      node.isExpanded = !node.isExpanded;
    } else {
      if (this.isActiveLink(node)) {
        return;
      }
      this.navigate(node);
    }
    this.cd.markForCheck();
  }

  public isActiveLink(node: NavMenu): boolean {
    const normalizedLink = normalizePath(node.id);
    const isActiveLink = this.activeNodeId.startsWith(normalizedLink);
    return isActiveLink && ((node.children && !node.isExpanded) || !node.children || this.isCollapsed);
  }

  public ngOnInit(): void {
    this.router.events
    .pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntilDestroyed(this.destroy)
    )
    .subscribe((event: NavigationEnd) => {
      this.activeNodeId = normalizePath(event.urlAfterRedirects);
      this.activeRootMenuItem = this.dataSource.find((item => this.activeNodeId.toLowerCase().startsWith(item.id.toLowerCase())));
      this.cd.markForCheck();
    });
  }

  public ngAfterViewInit(): void {
    this.appService.sideNavToggleStream.pipe(
      takeUntilDestroyed(this.destroy)
    ).subscribe(() => {
      this.isCollapsed = !this.isCollapsed;
      this.sidenav.toggle();
    });
  }

  public navigate(node: NavMenu): void {
    this.router.navigate([node.id]);
  }
}
